import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CandidateState,
  PhoneCandidateState,
  StateMap,
} from "../../../../lib/constant.ts";
import { get } from "../../../../api/ApiHelpers.ts";
import { FetchCandidatesListArgs } from "../type.tsx";
import { RootState } from "../../../../redux/store.ts";
import { search } from "jodit/esm/plugins/search/search.js";
import { logger } from "../../../../utils/consoleLogger.ts";

export const getWebCandidatesList = async (
  slug,
  interviewId,
  status,
  sortBy,
  page,
  pageSize,
  search,
  sourceUser=""
) => {
  let response;
  if (status == StateMap.PreInvite) {
    response = await get(
      `/company/${slug}/resume_candidate_list/?user=${sourceUser}&interview_type_ids=${interviewId}&ordering=${sortBy}&page=${page}&page_size=${pageSize || 10}&search=${search || ""}`
    );
  } else {
    // will remove 200 while doing pagination from API
    response = await get(
      `/company/${slug}/candidate_list_new_dashboard/?user=${sourceUser}&interview_type_ids=${interviewId}&ordering=${sortBy}&status=${CandidateState[status]}&page=${page}&page_size=${CandidateState[status] === CandidateState.Curated ? 200 : pageSize || 10}&search=${search || ""}`
    );
  }
  return response;
};

export const getPhoneCandidatesList = async (
  slug,
  interviewId,
  status,
  sortBy,
  page,
  pageSize,
  search,
  sourceUser=""
) => {
  // will remove 200 while doing pagination from API
  const response = await get(
    `/company/${slug}/phone_interview_candidate_list/?user=${sourceUser}&interview_type_ids=${interviewId}&ordering=${sortBy}&status=${PhoneCandidateState[status]}&page=${page}&page_size=${PhoneCandidateState[status] === PhoneCandidateState.Curated ? 200 : pageSize || 10}&search=${search || ""}`
  );
  return response;
};

export const fetchWebCandidatesList = createAsyncThunk(
  "candidateList/fetchWebCandidatesList",
  async (
    {
      slug,
      interviewId,
      status,
      pageSize,
      search,
      sourceUser,
    }: FetchCandidatesListArgs,
    { getState }
  ) => {
    try {
      const state = getState() as RootState;
      const { page, sortBy } = state?.webCandidates;
      const response = await getWebCandidatesList(
        slug,
        interviewId,
        status,
        sortBy,
        page,
        pageSize,
        search,
        sourceUser
      );
      return { data: response, status: status };
    } catch (error) {
      logger.error("Failed to fetch web candidates list", error);
    }
  }
);

export const fetchPhoneCandidatesList = createAsyncThunk(
  "candidateList/fetchPhoneCandidatesList",
  async (
    {
      slug,
      interviewId,
      status,
      pageSize,
      search,
      sourceUser,
    }: FetchCandidatesListArgs,
    { getState }
  ) => {
    try {
      const state = getState() as RootState;
      const { page, sortBy } = state?.phoneCandidates;
      const response = await getPhoneCandidatesList(
        slug,
        interviewId,
        status,
        sortBy,
        page,
        pageSize,
        search,
        sourceUser
      );
      return { data: response, status: status };
    } catch (error) {
      logger.error("Failed to fetch phone candidates list", error);
    }
  }
);
